export const styles = {
  field: {
    backgroundColor: '#f8f8f8',
    width: '100%',
    height: 36,
    paddingLeft: 16,
    borderRadius: 4,
    fontSize: 14,
    color: '546B81',
  },

  input: {
    width: '90%',
    paddingRight: '40px',
  },
  searchIcon: {
    position: 'absolute',
    right: 16,
    top: '57px',
    pointerEvents: 'none',
  },
  iconColor: {
    color: '#757575',
  },
  zipResults: {
    position: 'absolute',
    width: '100%',
    maxHeight: '152px',
    overflowY: 'auto',
    zIndex: 1000,
    marginTop: '4px',
    '& .MuiListItem-root': {
      padding: '6px 16px',
      fontSize: '14px',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
    },
    '& .MuiListItemText-primary': {
      fontSize: '14px',
    },
  },
  placeholder: {
    padding: '6px 16px',
    fontSize: '14px',
  },
  listItemContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  listItemMainText: {
    fontSize: 16,
    fontFamily: 'Proxima Nova, sans-serif',
    color: '#011533',
  },
  belowInputWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  limit: {
    fontSize: 14,
    fontFamily: 'Proxima Nova, sans-serif',
    color: '#505050',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 8,
    fontWeight: 600,
    lineHeight: '21px',
    whiteSpace: 'nowrap',
    gap: 4,
  },

  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 0,
  },
  chip: {
    backgroundColor: '#E2E2FC',
    borderRadius: 4,
    color: '#011533',
    marginRight: 8,
    marginTop: 8,
    cursor: 'default',
    //    '&:hover': {
    //      backgroundColor: '#646478',
    //    },
    '& .MuiChip-label': {
      padding: '6px 12px 6px 8px',
      fontSize: '16px',
    },

    '& .MuiChip-deleteIcon': {
      color: '#011533',
      fontSize: '16px',
      margin: '0 8px 0 0',
      padding: 0,
      cursor: 'pointer',
      //  '&:hover': {
      //    color: '#fff',
      //  },
    },
    '& .MuiChip-root': {
      backgroundColor: 'transparent',
    },
    '& .MuiChip-deletable': {
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
  },
  zipCodesContainer: {
    position: 'relative',
    width: '100%',
    paddingBottom: 16,
    borderBottom: '1px solid #E2E2FC',
    marginBottom: 16,
  },
  chipCloseIcon: {
    width: 16,
    height: 16,
    color: '#011533',
  },
  noDistributionZoneText: {
    fontSize: 14,
    fontFamily: 'Proxima Nova, sans-serif',
    color: 'red',
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: 4,
    fontWeight: 600,
    lineHeight: '21px',
  },
  whitelistedLocationsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  payAttention: {
    padding: '14px 16px',
    background: '#FFF4D4',
    borderRadius: 4,
  },
  mb8: {
    marginBottom: 8,
  },
  typesOfLocations: {
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 600,
    fontFamily: 'Proxima Nova, sans-serif',
    display: 'flex',
    flexDirection: 'row',
    padding: '8px 16px',
    background: '#F3F3FF',
    borderRadius: 4,
    marginTop: 8,
    gap: 16,
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#707087',
    marginBottom: 8,
  },
  locationType: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  whiteListLocationsInputWrapper: {
    position: 'relative',
    width: '100%',
    marginBottom: 36,
  },
  locationLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  limitExceeded: {
    background: '#FFA4B5',
    borderRadius: 4,
    padding: '4px 8px',
  },
  locationSelectItem: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: 40,
  },
  footerWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  footerContent: {
    display: 'flex',
    gap: 40,
  },
  footerItem: {
    fontSize: 14,
    fontFamily: 'Proxima Nova, sans-serif',
    color: '#707087',
    fontWeight: 700,
    lineHeight: '22px',
  },
}
